import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comNavType/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getListTree = query => {

    var list = request({
        url: 'comNavType/getListTree.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const fetchSelect = query => {  
    var list = request({
        url: 'comNavType/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comNavType/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comNavType/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comNavType/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comNavType/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




